import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Context } from 'src/app/shared/models/context';
import { Timeline } from 'src/app/shared/models/domain';
import { AuthService } from 'src/app/shared/services/auth.service';
import { EmployeeService } from 'src/app/shared/services/employee.service';

@Component({
  selector: 'app-timelines',
  templateUrl: './timelines.component.html',
  styleUrls: ['./timelines.component.scss']
})
export class TimelinesComponent implements OnInit {

  public timelines: Timeline[] = [];
  public evenTimelines: any[] = [];
  public oddTimelines: any[] = [];
  public context: Context;
  private subscription: Subscription;
  constructor(private employeeService:EmployeeService ,private authService:AuthService  ) { }

  ngOnInit(): void {
  this.subscription= this.authService.getContext().subscribe(context=>{
      if(context.employeeId){
      this.context = context;
      this.employeeService.getTimelines(this.context.employeeId).subscribe(timelines=>this.timelines=timelines);
  }
  });

  }
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

}
